import {gql} from "@irati/utils/gql"
import fullTenantSettings from "./FullTenantSettings"

const fragment = gql`
  fragment fullTenant on Tenant {
    uuid
    groupId
    locale
    subdomain
    public_name
    rootTeamId
    settings {
      ...fullTenantSettings
    }
  }
  ${fullTenantSettings}
`

export const toString = fragment.loc.source.body

export default fragment
